import { loadStripe } from '@stripe/stripe-js';
import { toast } from '../hooks/use-toast';
import axios from 'axios';
import { applyDiscount, isDiscountActive, DISCOUNT_PERCENT } from './discount';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Initialize Stripe (kept for potential future client-side use)
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const createStripeCheckout = async (bookName, bookType, price, currency) => {
  try {
    const finalPrice = applyDiscount(price);
    const finalName = isDiscountActive()
      ? `${bookName} — ${DISCOUNT_PERCENT}% OFF Flash Sale`
      : bookName;

    const response = await axios.post(`${API}/stripe/create-checkout-session`, {
      book_name: finalName,
      book_type: bookType,
      price: finalPrice,
      currency,
    });
    window.location.href = response.data.url;
  } catch (_err) {
    toast({
      title: 'Payment unavailable',
      description: 'We could not start checkout. Please try again in a moment.',
      variant: 'destructive',
    });
  }
};
